module.exports = __webpack_public_path__ + "static/media/YM05_4.5e5ced0e.jpg";